import React, {useContext, useState} from 'react';
import PropTypes from "prop-types";

import ProductImage from "./components/ProductImage";
import ProductDetails from "./components/ProductDetails";

import {ProductShowContext} from "../../context/ProductShowContext";
import ProductImageCarousel from "./components/ProductImageCarousel";

ProductResume.propTypes = {
    image: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.string),
    status: PropTypes.bool,
    name: PropTypes.string,
    eshopId: PropTypes.string,
    sku: PropTypes.string,
    price: PropTypes.number,
    stock: PropTypes.number,
    updatedAt: PropTypes.node,
    url: PropTypes.string,
    lastPushedAt: PropTypes.node,
    visualScore: PropTypes.number,
    firstVariation: PropTypes.object,
    benchmarkPrice: PropTypes.number,
    priceCompetitiveness: PropTypes.number,
    validated: PropTypes.bool
};

function ProductResume({
    image,
    images,
    status,
    name,
    eshopId,
    sku,
    price,
    stock,
    updatedAt,
    lastPushedAt,
    url,
    visualScore,
    firstVariation,
    benchmarkPrice,
    priceCompetitiveness,
    validated
}) {
    const {switchVariation} = useContext(ProductShowContext);

    const [selected, setSelected] = useState(0);

    const displayedImage = images?.[selected] ?? image;

    return (
        <div
            style={{ cursor: 'pointer' }}
            onClick={() => switchVariation(null)}
        >
            <ProductImage
                image={displayedImage}
                status={status}
                visualScore={visualScore}
                validated={validated}
            />
            <ProductImageCarousel
                images={images}
                selected={selected}
                onSelect={setSelected}
            />
            <ProductDetails
                name={name}
                eshopId={eshopId}
                sku={sku}
                price={price}
                stock={stock}
                updatedAt={updatedAt}
                lastPushedAt={lastPushedAt}
                url={url}
                status={status}
                firstVariation={firstVariation}
                totalImages={images?.length ?? 0}
                benchmarkPrice={benchmarkPrice}
                priceCompetitiveness={priceCompetitiveness}
            />
        </div>
    );
}

export default ProductResume;
